import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '../../styles'
import styles from './styles'

const ProgressBar = ({ progress, color, bgColor }) => (
  <div
    className="ProgressBar"
    style={{
      backgroundColor: bgColor,
    }}
  >
    <div
      className="progress"
      style={{
        width: `${Math.floor(limitProgress(progress) * 100)}%`,
        backgroundColor: color,
      }}
    />
    <style jsx>{styles}</style>
  </div>
)
function limitProgress(progress) {
  return Math.min(
    1,
    Math.max(
      0,
      Number(progress)
    )
  )
}

ProgressBar.propTypes = {
  progress: PropTypes.number,
  color: PropTypes.string,
  bgColor: PropTypes.string,
}
ProgressBar.defaultProps = {
  progress: 0,
  color: colors.textHoverPurple,
  bgColor: colors.textInput,
}

export default ProgressBar
